module.exports = function() {
  return new Worker(__webpack_public_path__ + "d1ec3b07434b2e56d545.worker.js");
};